import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-company-holiday-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgbDatepickerModule, JsonPipe],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './company-holiday-form.component.html',
  styleUrl: './company-holiday-form.component.scss'
})
export class CompanyHolidayFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;
  Holidays = [] as any;
  Years = [] as any;
  HolidayMappingDetail = {
    ESS_CompanyHolidayMasterID: 0,
    Year: null as any,
    Date: null as any,
    DateObj: null as any,
    ESS_HolidayMasterId: null,
    SelectType: 'insert'
  }
  filter = {
    CalendarMinDate: null as any,
    CalendarMaxDate: null as any,
  }

  constructor(
    private holiday: HolidayService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    protected tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.HolidayMappingDetail.ESS_CompanyHolidayMasterID = this.ID;
    this.SelectDate('RegistrationDate', null, null);
  }
  ngOnInit(): void {
    if (this.ID > 0) {
      this.GetCompanyHolidayMaping();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.HolidayMappingDetail.Year != null && this.HolidayMappingDetail.DateObj != null && this.HolidayMappingDetail.ESS_HolidayMasterId != null) {
        this.SaveCompanyHoliday();
      }
    }
    else {
      form.submitted = true;
    }
  }

  GetHoliday() {
    this.isDisabled = true;
    this.Holidays = [];
    this.holiday.GetCompanyHoliday({ ESS_CompanyHolidayMasterID: this.HolidayMappingDetail.ESS_CompanyHolidayMasterID, SelectType: 1, Year: this.HolidayMappingDetail.Year }).subscribe({
      next: (response) => {
        this.Holidays = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetCompanyHolidayMaping() {
    this.HolidayMappingDetail.ESS_CompanyHolidayMasterID = this.ID;
    this.isDisabled = true;
    this.holiday.GetCompanyHoliday({ ESS_CompanyHolidayMasterID: this.HolidayMappingDetail.ESS_CompanyHolidayMasterID, SelectType: 2 }).subscribe({
      next: (response) => {
        this.HolidayMappingDetail.ESS_CompanyHolidayMasterID = response.Table[0].ESS_CompanyHolidayMasterID;
        this.HolidayMappingDetail.Year = parseInt(response.Table[0].Year);
        //const dateMoment = moment(response.Table[0].Date);
        // this.HolidayMappingDetail.Date = {
        //   year: dateMoment.year(),
        //   month: dateMoment.month() + 1, // NgbDateStruct month is 1-based
        //   day: dateMoment.date(),
        // };
        this.HolidayMappingDetail.DateObj = this.dateFormate.parse(response.Table[0].Date);
        //this.HolidayMappingDetail.Date = moment(response.Table[0].Date);
        this.HolidayMappingDetail.ESS_HolidayMasterId = response.Table[0].ESS_HolidayMasterId;
        this.HolidayMappingDetail.SelectType = 'update';
        this.SetCalendarDate();
        this.GetHoliday();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveCompanyHoliday() {
    await this.common.getPageRights();

    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result: any) => {
      if (result) {
        if ((this.ID == 0 && this.common.PageRight.IsAdd) || (this.ID > 0 && this.common.PageRight.IsEdit)) {
          this.isDisabled = true;
          this.HolidayMappingDetail.ESS_CompanyHolidayMasterID = this.ID;
          this.HolidayMappingDetail.Date = this.dateFormate.format(this.HolidayMappingDetail.DateObj); //this.HolidayMappingDetail.Date.year + '-' + this.HolidayMappingDetail.Date.month + '-' + this.HolidayMappingDetail.Date.day;
          this.holiday.SaveCompanyHoliday(this.HolidayMappingDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '381' || response.Error_Code == '383') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close(true);
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  SetCalendarDate() {
    this.filter.CalendarMinDate = this.dateFormate.parse("01 Jan " + this.HolidayMappingDetail.Year);
    this.filter.CalendarMaxDate = this.dateFormate.parse("31 Dec " + this.HolidayMappingDetail.Year);
  }

  close() {
    this.activeModal.close();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
}
